/**
 * Chiavi di cache, in un posto solo.
 *
 * Sparse fra i componenti diventano stringhe scritte a mano che divergono, e
 * una invalidazione che non combacia è un bug silenzioso: i dati restano
 * vecchi e nessuno se ne accorge finché non ricarica la pagina.
 */
export const queryKeys = {
  groups: ["groups"] as const,
  group: (groupId: string) => ["groups", groupId] as const,
  members: (groupId: string) => ["groups", groupId, "members"] as const,
  expenses: (groupId: string) => ["groups", groupId, "expenses"] as const,
  balances: (groupId: string) => ["groups", groupId, "balances"] as const,
  settlements: (groupId: string) => ["groups", groupId, "settlements"] as const,
  invites: (groupId: string) => ["groups", groupId, "invites"] as const,
  invitePreview: (code: string) => ["invites", code] as const,
  timeline: (groupId: string) => ["groups", groupId, "timeline"] as const,
  activity: (categories: readonly string[] = []) => ["activity", ...categories] as const,
  friends: ["friends"] as const,
  friend: (key: string) => ["friends", key] as const,
  stats: (groupId: string, period: string, month: string | null) =>
    ["groups", groupId, "stats", period, month] as const,
};
